/** Parse UA date `dd.MM.yyyy` to ms (local calendar day bounds). */
export const parseUaDateToMs = (value, { endOfDay = false } = {}) => {
  if (!value || typeof value !== 'string') return undefined
  const trimmed = value.trim()
  if (!/^\d{2}\.\d{2}\.\d{4}$/.test(trimmed)) return undefined
  const [day, month, year] = trimmed.split('.').map(Number)
  const date = endOfDay
    ? new Date(year, month - 1, day, 23, 59, 59, 999)
    : new Date(year, month - 1, day, 0, 0, 0, 0)
  const ms = date.getTime()
  return Number.isNaN(ms) ? undefined : ms
}

export const formatCustomerTimestamp = (value) => {
  if (value == null || value === '') return '—'
  const ms = typeof value === 'number' ? value : value?.seconds ? value.seconds * 1000 : null
  if (ms == null || Number.isNaN(ms)) return '—'
  try {
    return new Date(ms).toLocaleString('uk-UA', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch (error) {
    return '—'
  }
}

export const formatCustomerName = (firstName, lastName) => {
  const name = [firstName, lastName]
    .map((part) => (part == null ? '' : String(part).trim()))
    .filter(Boolean)
    .join(' ')
  return name || '—'
}

export const formatOptionalText = (value) => {
  if (value == null) return '—'
  const trimmed = String(value).trim()
  return trimmed === '' ? '—' : trimmed
}

/** Normalize for case-insensitive UA name search. */
export const normalizeCustomerNameQuery = (raw) => {
  if (raw == null) return ''
  return String(raw).trim().toLowerCase().replace(/\s+/g, ' ')
}

export const customerMatchesNameQuery = (item, nameQuery) => {
  const query = normalizeCustomerNameQuery(nameQuery)
  if (!query) return true
  const fullName = `${item?.firstName || ''} ${item?.lastName || ''}`
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
  return fullName.includes(query)
}

export const DEFAULT_CUSTOMERS_LIST_LIMIT = 100
export const CUSTOMERS_NAME_SEARCH_FETCH_LIMIT = 500
